import {
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridOptions } from 'ag-grid';
import { ComplaintsService } from '../../../../../services/complaints.service';
import { T2CardComponent } from '../../../../../trip2-theme/components/t2-card/t2-card.component';
import { ParentModule } from '../../../../A2-utils/ParentClass/parent-module';
import { Subscription } from 'rxjs/Subscription';
import { assignNewArray, messagePermits } from '../../../../A2-utils/export-functions/functions-services';
import { INoteCategory } from '../../../../../core/interfaces/complaints.interface';
import { IResponseError } from '../../../../../core/interfaces/response.interface';
import { CompanyService } from '../../../../../core/services/company.service';
import { ICompany } from '../../../../../core/interfaces/company.interface';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { IComplaintHistory } from '../../../../../core/interfaces/complaint-history.interface';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-manager-complaint',
  templateUrl: './manager-complaint.component.html',
  styleUrls: ['./manager-complaint.component.scss']
})
export class ManagerComplaintComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  @ViewChild('complaintFormCard') complaintFormCard: T2CardComponent;
  @ViewChild('fileInput') fileInput: ElementRef
  public isClientUser: boolean = JSON.parse(localStorage.getItem('currentUser')).isClient;
  @Input() tripnote?: any;
  @Output() emitterCard: EventEmitter<any> = new EventEmitter<any>();
  @Output() onReload?: EventEmitter<any> = new EventEmitter<any>();
  protected gridTrips: GridOptions;
  protected formComplaints: FormGroup;
  protected formResponse: FormGroup;
  protected agGridData: IComplaintHistory[] = [];
  protected statusSelect: any;
  protected CategorySelect: any;
  protected AssignToSelect: any;
  public tabs = 1;
  public validDescription = false;
  public viewComplaints = false;
  public actionsComplaints: string[] = [];
  public reportedBy: INoteCategory[] = [];
  public providers: ICompany[] = [];
  reviewStatuses: any[];
  selectedTripNote: any;
  editComplaint = false;
  private subscriptions: Subscription[] = [];
  public nid: any;
  nameFileAttachment: string;
  constructor(
    protected fb: FormBuilder,
    private _complaintService: ComplaintsService,
    private _companyService: CompanyService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    protected _loading: T2LoadingService
  ) {
    super('complaint', Inject);
    this.createForm();
    this.subscriptions.push(
      this.$actions.subscribe((data: string[]) => {
        this.verifyActions(data);
      }));
    this.gridTrips = <GridOptions>{
      enableSorting: true,
      sortingOrder: ['desc', 'asc', null],
      onGridReady: (params) => {
        params.api.sizeColumnsToFit();
      }
    };
    this.gridTrips.columnDefs = this.createColums();
    this.getNoteCategoryValues();
    this._complaintService.getNoteCategoryValues(7).subscribe(
      (data: INoteCategory[]) => {
        this.reportedBy = data;
        if (this.isClientUser && data.length === 1) {
            this.formComplaints.get('complaintreportedbyid').setValue(data[0].notecategoryvalueid);
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tripnote'] && this.tripnote) {
      this.editComplaint = false;
      if (this.formComplaints) {
        this.formComplaints.disable();
      }
      this.getComplaintsHeader();
      this.formResponse.reset();
      this.formResponse.enable();
    }
  }

  ngOnInit() {
    this.getReviewStatuses();
    this.getProviders();
  }
  private verifyActions(actions: string[]): void {
    this.actionsComplaints = assignNewArray(actions);
    this.viewComplaints = this.actionsComplaints.includes('View');
  }

  createForm() {
    this.formComplaints = this.fb.group({
      tripid: ['', Validators.required],
      moduleid: ['', Validators.required],
      note: this.fb.group({
        noteid: [''],
        notetypeid: ['', Validators.required],
        description: ['', Validators.required],
        isalllegs: [false],
        notecomplaintid: ['', Validators.required],
        notestatusid: ['', Validators.required],
        complaintreportedbyid: ['', Validators.required],
        caller: ['', Validators.required],
        complaintproviderid: ['', Validators.required],
        calleremail: [null, Validators.required],
        ahcacomplaintid: [null]
      })
    });

    this.formResponse = this.fb.group({
      ComplaintHistoryId: [''],
      noteid: [''],
      description: ['', Validators.required],
      complaintstatusid: [''],
      complaintreviewstatusid: [null, Validators.required],
      attachment: [null],
      mimetype: []
    });
    this.formResponse.get('description').valueChanges.subscribe(
      (value) => {
        this.validDescription = !!value;
      }
    );
  }

  createColums() {
    const columns = [
      { headerName: 'Response', field: 'description', colId: 'Trip', width: 100 },
      { headerName: 'Date', field: 'date', colId: 'Trip', width: 80 },
      { headerName: 'Review Status', field: 'complaintreviewstatus', colId: 'Trip', width: 100 },
      { headerName: 'User', field: 'user', colId: 'Trip', width: 100 },
      { headerName: 'Complaint Status', field: 'complaintstatus', width: 100 }
    ];
    return columns;
  }

  getNoteCategoryValues() {
    this._complaintService.getNoteCategoryValues(5).subscribe((resp) => {
      this.statusSelect = resp;
    });

    this._complaintService.getNoteCategoryValues(4).subscribe((resp) => {
      this.CategorySelect = resp;
    });
  }

  getHistorySearchByNote(noteId) {
    this.subscriptions.push(
      this._complaintService.getHistorySearchByNote(noteId).subscribe(resp => {
        if (resp && resp.length) {
          this.agGridData = resp;
        }
      })
    );
  }

  onEditComplaints() {
    if (this.actionsComplaints.includes('Update')) {
      this.editComplaint = !this.editComplaint;
      this.editComplaint ? this.formComplaints.enable() : this.formComplaints.disable();

      if (!this.editComplaint && this.validateEmailAndCaller()) {
        this._loading.show();
        this._complaintService.putTripNote(this.formComplaints.value)
          .finally(() => this._loading.hiden())
          .subscribe((resp: any) => {
          if (resp.success) {
            this.sweetAlertHelper.createCustomAlert({
              type: 'success',
              title: `${resp.message}`,
              showConfirmButton: true,
            }).then(() => {
              this.onReload.emit(true);
            });
          } else {
            alert('Error: ' + JSON.stringify(resp));
          }
        },
          error => {
            this.messageResponseError(error);
          });
      }
    } else {
      messagePermits('Edit Complaints');
    }
  }

  private validateEmailAndCaller(): boolean {
    const note = this.formComplaints.get('note');
    if (note) {
      const emails = note.get('calleremail').value;
      const caller = note.get('caller').value;

      if (!emails) {
        this.handleValidationError('The Caller Email is required');
        return false;
      }

      if (!caller) {
        this.handleValidationError('The Caller field is required');
        return false;
      }
    }
    return true;
  }

  private handleValidationError(message: string): void {
    this.formComplaints.enable();
    this.editComplaint = !this.editComplaint;
    this.sweetAlertHelper.captureException(message);
  }

  onSend(status: number) {
    this._loading.show('Loading...')
    if (this.actionsComplaints.includes('Update')) {
      this.formResponse.patchValue({ complaintstatusid: status });
      if (this.formResponse.get('ComplaintHistoryId').value) {
      this.subscriptions.push(
        this._complaintService.managerComplaintHistory(this.formResponse.value, 'PUT')
          .pipe(
            finalize(() => {
              this._loading.hiden();
            })
          ).subscribe((resp:any) => {
            if (resp.success) {
              this.sweetAlertHelper.createCustomAlert({
                type: 'success',
                title: `${resp.message}`,
                showConfirmButton: true,
              }).then(() => {
                this.getHistorySearchByNote(this.selectedTripNote.note.noteid);
                this.formResponse.reset();
                this.onReload.emit(true);
                this.onClearFile();
              });

            } else {
              this.sweetAlertHelper.captureException(`${JSON.stringify(resp) }`)
            }
          },
          error => {
            this.messageResponseError(error);
            this.onClearFile();
          }
        )
      );
      } else {
        this.formResponse.patchValue({ noteid: this.selectedTripNote.note.noteid });
        this.subscriptions.push(
          this._complaintService.managerComplaintHistory(this.formResponse.value, 'POST').pipe(
            finalize(() => {
              this._loading.hiden();
            })
          ).subscribe((resp:any) => {
          if (resp.success) {
            this.sweetAlertHelper.createCustomAlert({
              type: 'success',
              title: `${resp.message}`,
              showConfirmButton: true,
            }).then(() => {
              this.formResponse.reset();
              this.onReload.emit(true);
              this.getComplaintsHeader();
              this.onClearFile();
            });

          } else {
            this.sweetAlertHelper.captureException(`${JSON.stringify(resp)}`);
          }
        },
          error => {
            this.onClearFile();
            this.messageResponseError(error);

          })
        );
      }
    } else {
      messagePermits('Edit Complaints');
    }
  }

  setFormData(event: IComplaintHistory) {
    if (event) {
      this.formResponse.patchValue({
        noteid: this.selectedTripNote.note.noteid,
        ComplaintHistoryId: event.complainthistoryid,
        description: event.description,
        complaintstatusid: event.complaintstatusid,
        complaintreviewstatusid: event.complaintreviewstatusid
      });
      this.formResponse.disable();
    }
  }

  onCancel() {
    this.formResponse.reset();
    this.formResponse.enable();
    this.onClearFile();
  }

  getComplaintsHeader() {
    this.subscriptions.push(
      this._complaintService.getComplaintsHeader(this.tripnote.tripnoteid).subscribe((resp) => {
        if (resp) {
          this.nid = resp.noteid;
          this.selectedTripNote = resp;
          this.setDataHeader();
        }
      })
    );
  }

  setDataHeader() {
    this.formComplaints.patchValue({
      tripid: this.selectedTripNote.tripid,
      moduleid: this.selectedTripNote.moduleid,
      note:
      {
        noteid: this.selectedTripNote.note.noteid,
        notetypeid: this.selectedTripNote.note.notetypeid,
        notecomplaintid: this.selectedTripNote.note.notecomplaintid,
        notestatusid: this.selectedTripNote.note.notestatusid,
        description: this.selectedTripNote.note.description,
        complaintreportedbyid: this.selectedTripNote.note.complaintreportedbyid,
        caller: this.selectedTripNote.note.caller,
        complaintproviderid: this.selectedTripNote.note.complaintproviderid,
        calleremail: this.selectedTripNote.note.calleremail,
        ahcacomplaintid: this.selectedTripNote.note.ahcacomplaintid
      }
    });
    this.getHistorySearchByNote(this.selectedTripNote.note.noteid);
    this.formComplaints.disable();
  }

  private getReviewStatuses() {
    this._complaintService.getNoteCategoryValues(6).subscribe({
      next: response => {
        this.reviewStatuses = response;
      }
    });
  }

  /**
   * @name messageResponseError
   * @description messages error
   */
  messageResponseError(respon: IResponseError) {
    const entity: string[] = respon.modelstate ? respon.modelstate['entity.description'] : [];
    const html = [];
    if (entity.length) {
      entity.forEach((data: string) => {
        html.push(`<div><span class="font-w-bold"> Error: </span><span class="color-danger">${data}</span></div>`);
      });
    } else {
      html.push(`<div><span class="font-w-bold"> ${respon.message} </span></div>`);
    }
    this.sweetAlertHelper.createCustomAlert({
      title: 'Error',
      html: `${html}`,
      type: 'error'
    });
  }
  /**
   * @description trae todos los provider
   */
  private getProviders(): void {
    this.subscriptions.push(this._companyService.get().subscribe(
      (providerList: ICompany[]) => {
        this.providers = providerList;
      }
    ));
  }

  uploadFile(event): void {
    const file = event.target.files[0];
    if (file) {
      this.nameFileAttachment = file.name;
      this.formResponse.get('mimetype').setValue(file.type);
      const reader = new FileReader();
      reader.onload = this.readerLoadedFile.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  readerLoadedFile(readerFile): void {
    const binaryString = readerFile.target.result;
    const base64 = btoa(binaryString);
    if (base64) {
      this.formResponse.get('attachment').setValue(base64);
    }
  }

  onClearFile(): void {
    this.fileInput.nativeElement.value = '';
    this.nameFileAttachment = '';
    this.formResponse.patchValue({
      attachment: null,
      mimetype: null
    });
  }

  get showNameAttachment(): string {
    return this.nameFileAttachment ? this.nameFileAttachment : 'No File Chosen';
  }

  get deleteFile(): boolean {
    return this.formResponse.get('attachment').value;
  }

  get disabledBtnAttachment(): boolean {
    return this.formResponse.get('ComplaintHistoryId').value;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/complaints/complaints-resolution/components/manager-complaint/manager-complaint.component.ts